export const GET_CURRENT_SCHEDULE = 'calendar/GET_CURRENT_SCHEDULE'
export const GET_CURRENT_SCHEDULE_SUCCESS = 'calendar/GET_CURRENT_SCHEDULE_SUCCESS'
export const GET_CURRENT_SCHEDULE_ERROR = 'calendar/GET_CURRENT_SCHEDULE_ERROR'

export const GET_APPOINTMENT = 'calendar/GET_APPOINTMENT'
export const GET_APPOINTMENT_SUCCESS = 'calendar/GET_APPOINTMENT_SUCCESS'
export const GET_APPOINTMENT_ERROR = 'calendar/GET_APPOINTMENT_ERROR'

export const EDIT_SCHEDULE = 'calendar/EDIT_SCHEDULE'
export const EDIT_SCHEDULE_SUCCESS = 'calendar/EDIT_SCHEDULE_SUCCESS'
export const EDIT_SCHEDULE_ERROR = 'calendar/EDIT_SCHEDULE_ERROR'

export const DELETE_CALENDAR_EVENT = 'calendar/DELETE_CALENDAR_EVENT'
export const DELETE_CALENDAR_EVENT_SUCCESS = 'calendar/DELETE_CALENDAR_EVENT_SUCCESS'
export const DELETE_CALENDAR_EVENT_ERROR = 'calendar/DELETE_CALENDAR_EVENT_ERROR'

export const ADD_TO_SCHEDULE = 'calendar/ADD_TO_SCHEDULE'
export const ADD_TO_SCHEDULE_SUCCESS = 'calendar/ADD_TO_SCHEDULE_SUCCESS'
export const ADD_TO_SCHEDULE_ERROR = 'calendar/ADD_TO_SCHEDULE_ERROR'

export const GET_SCHEDULE_BY_ID = 'calendar/GET_SCHEDULE_BY_ID'
export const GET_SCHEDULE_BY_ID_SUCCESS = 'calendar/GET_SCHEDULE_BY_ID_SUCCESS'
export const GET_SCHEDULE_BY_ID_ERROR = 'calendar/GET_SCHEDULE_BY_ID_ERROR'

export const GET_PATIENT = 'calendar/GET_PATIENT'
export const GET_PATIENT_SUCCESS = 'calendar/GET_PATIENT_SUCCESS'
export const GET_PATIENT_ERROR = 'calendar/GET_PATIENT_ERROR'

export const CANCEL_VISIT = 'calendar/CANCEL_VISIT'
export const CANCEL_VISIT_SUCCESS = 'calendar/CANCEL_VISIT_SUCCESS'
export const CANCEL_VISIT_ERROR = 'calendar/CANCEL_VISIT_ERROR'

export const SET_ERROR = 'calendar/SET_ERROR'
export const SET_IS_APPOINTMENT_POPUP_SHOWN = 'calendar/SET_IS_APPOINTMENT_POPUP_SHOWN'
export const SET_LOADING = 'calendar/SET_LOADING'
export const SET_IS_SUCCESS_SCHEDULE_EDIT = 'calendar/SET_IS_SUCCESS_SCHEDULE_EDIT'
export const SET_IS_DELETE_CALENDAR_EVENT_SUCCESS = 'calendar/SET_IS_DELETE_CALENDAR_EVENT_SUCCESS'
export const SET_CALENDAR_RANGE_BEFORE_NEW_VISIT = 'calendar/SET_CALENDAR_RANGE_BEFORE_NEW_VISIT'
export const SET_CALENDAR_OFFSET_BEFORE_NEW_VISIT = 'calendar/SET_CALENDAR_OFFSET_BEFORE_NEW_VISIT'

export const RESET_SCHEDULE_RECURRING_INFO = 'calendar/RESET_SCHEDULE_RECURRING_INFO'

export const GET_VISIT_TYPE_GROUPS = 'calendar/GET_VISIT_TYPE_GROUPS'
export const GET_VISIT_TYPE_GROUPS_SUCCESS = 'calendar/GET_VISIT_TYPE_GROUPS_SUCCESS'
export const GET_VISIT_TYPE_GROUPS_ERROR = 'calendar/GET_VISIT_TYPE_GROUPS_ERROR'

export const apiErrorCodes = {
  VISIT_NOT_FOUND: 'VisitNotFound',
  FORBIDDEN: 'Forbidden',
  PROVIDER_NOT_FOUND: 'ProviderNotFound',
}
export const text = {
  VISIT: 'visit',
  PROVIDER: 'provider',
}
